import { BlockComponent } from './components/block/block.component';
import { BlockEditComponent } from './containers/block-edit/block-edit.component';
import { BlockRoutingModule } from './block-routing.module';
import { CommonModule } from '@angular/common';
import { ErrorTailorModule } from '@ngneat/error-tailor';
import { MarkdownModule } from 'ngx-markdown';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ThemeModule } from '../../theme/theme.module';
import { TranslocoModule } from '@ngneat/transloco';
import { UiModule } from '../ui/ui.module';
import { UploadModule } from '../upload/upload.module';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
  declarations: [BlockComponent, BlockEditComponent],
  imports: [
    // Angular
    CommonModule,
    ReactiveFormsModule,
    RouterModule,

    // Material
    MatSnackBarModule,
    MatFormFieldModule,
    MatButtonModule,
    MatDialogModule,
    MatListModule,
    MatIconModule,

    // Other
    MarkdownModule.forRoot(),

    // Custom
    UploadModule,
    ThemeModule,
    BlockRoutingModule,
    UiModule,
    ErrorTailorModule,
    TranslocoModule,

    DirectivesModule,
  ],
  exports: [BlockComponent],
})
export class BlockModule {}
